var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { BackgroundProvider } from '../BackgroundContext/index.js';
const Title = ({ children }) => {
    return React.createElement("h3", { className: "text-basicSurface-900" }, children);
};
const Description = ({ children, className }) => {
    return (React.createElement("div", { className: clsx('max-w-8xl text-basicSurface-500', className) },
        React.createElement("p", null, children)));
};
const PlacementBottom = ({ title, description, children }) => (React.createElement(React.Fragment, null,
    title && React.createElement(Title, null, title),
    description && (React.createElement(Description, { className: clsx(title && 'mt-2') }, description)),
    children && React.createElement("div", { className: "mt-5 text-sm" }, children)));
const PlacementTrailing = ({ title, description, children }) => (React.createElement(React.Fragment, null,
    title && React.createElement(Title, null, title),
    React.createElement("div", { className: clsx('sm:flex sm:items-start sm:justify-between', title && 'mt-2') },
        description && React.createElement(Description, { className: "" }, description),
        children && (React.createElement("div", { className: "mt-5 text-sm sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center" }, children)))));
const PlacementTrailingTop = ({ title, description, children }) => (React.createElement("div", { className: "sm:flex sm:items-start sm:justify-between" },
    React.createElement("div", null,
        title && React.createElement(Title, null, title),
        description && (React.createElement(Description, { className: clsx(title && 'mt-2') }, description))),
    children && (React.createElement("div", { className: "mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center" }, children))));
export const ActionPanel = props => {
    const { as, title, description, children, placement = 'bottom', className } = props, rest = __rest(props, ["as", "title", "description", "children", "placement", "className"]);
    const Component = as || 'div';
    return (React.createElement(BackgroundProvider, { backgroundType: "surface" },
        React.createElement(Component, Object.assign({ className: clsx('bg-surface-50 text-basicSurface-500 shadow sm:rounded-lg', className) }, rest),
            React.createElement("div", { className: "px-4 py-5 sm:p-6" },
                placement === 'bottom' && (React.createElement(PlacementBottom, { title: title, description: description }, children)),
                placement === 'trailing' && (React.createElement(PlacementTrailing, { title: title, description: description }, children)),
                placement === 'trailing-top' && (React.createElement(PlacementTrailingTop, { title: title, description: description }, children))))));
};
//# sourceMappingURL=ActionPanel.js.map